<template>
  <div class>
    <Nav></Nav>
    <mdb-container class="mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h1 class>Your team</h1>
        </mdb-col>
      </mdb-row>
      <mdb-row class>
        <mdb-col sm="12" xl="12" class>
          <div
            class="team-list-item"
            v-for="(item,index) in teamArrayForView"
            :key="'member'+index"
          >
            <router-link v-if="item!==''" :to="mthConstructLinkToMember(item)">
              <span class="avatar">{{item && item.substr(0,2)}}</span>
              <div class="team-list-item-main">
                <h5 class="uppercase" v-if="mthGetProfileByEmail(item).profile">{{ item }}</h5>
                <h5 v-else>(nickname not set in profile)</h5>
                <div class>
                  <span class="w-100">
                    Go to profile
                    <mdb-badge v-if="false" pill color="bg-green" class>COMPLETED</mdb-badge>
                  </span>
                </div>
              </div>
            </router-link>
          </div>

          <!-- <div class="team-list-item">
            <router-link to="/team/member">
              <span class="avatar">JS</span>
              <div class="team-list-item-main">
                <h5 class="uppercase">John Smith</h5>
                <div class="progress-list-item-line">
                  <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                </div>
              </div>
            </router-link>
          </div>
          <div class="team-list-item">
            <router-link to="/team/member">
              <span class="avatar">BE</span>
              <div class="team-list-item-main">
                <h5 class="uppercase">Becky DosSantos</h5>
                <div class="progress-list-item-line">
                  <span>
                    Sales Skills Assessment:
                    <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                  </span>
                </div>
              </div>
            </router-link>
          </div>
          <div class="team-list-item">
            <router-link to="/team/member">
              <span class="avatar">EM</span>
              <div class="team-list-item-main">
                <h5 class="uppercase">Emily Saunders</h5>
                <div class="progress-list-item-line">
                  <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                </div>
              </div>
            </router-link>
          </div>-->
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import firebase from "firebase/app";
import moment from "moment";
import { store } from "../store";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";
import { SSL_OP_SINGLE_DH_USE } from "constants";

export default {
  name: "Team",
  data: function() {
    return {
      teamArrayOfStrings: [],
      teamArrayForView: [],
      teamArrayOfObjects: []
    };
  },
  created() {
    this.mthFillteamArrayOfStringsWithEmails();
  },
  methods: {
    mthConstructLinkToMember(email) {
      let em = email.replace("@", "_");
      em = em.replace(".", "__");
      return "/team/member/" + em;
    },
    mthGetProfileByEmail(email) {
      let that = this;

      let toret = {};
      if (this.teamArrayOfStrings.indexOf(email) >= 0) {
        //exists, will move
        let userProfileDocRef = firebase
          .firestore()
          .collection("usersProfiles")
          .doc(email)
          .get()
          .then(function(doc) {
            //console.log("mthGetProfileByEmail: ");
            //console.log(doc.data());

            //remove from array of strings to inform that data is present in array of objects
            for (var i = 0; i < that.teamArrayOfStrings.length; i++) {
              if (that.teamArrayOfStrings[i] === email) {
                that.teamArrayOfStrings.splice(i, 1);
              }
            }

            that.teamArrayOfObjects.push({
              email: email,
              profile: doc.data()
            });

            toret = {
              email: email,
              profile: doc.data()
            };
          })
          .then(() => {
            //console.log("then then says:");
            //console.log(that.teamArrayOfObjects);
          });
      } else {
        toret = this.teamArrayOfObjects.find(o => o.email === email);
      }

      return toret;
    },
    mthFillteamArrayOfStringsWithEmails() {
      let that = this;
      let userProfileDocRef = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(that.$store.getters.getUser.email);

      let userProfileDoc = userProfileDocRef
        .get()
        .then(doc => {
          //console.log(doc.data());

          if (!doc.exists) {
            /*             console.log(
              "userProfileDoc not exists for " + store.getters.getUser.email
            ); */
          } else {
            //console.log("userProfileDoc data:", doc.data());
            this.teamArrayOfStrings = doc.data().team;
            this.teamArrayForView = doc.data().team;
          }
        })
        .catch(err => {
          //console.log("userProfileDoc - Error getting document", err);
        });
    }
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
